import React, { useState, useEffect } from "react";
import { Formik, Form, Field } from "formik";
import axios from "axios";
import { BsImages } from "react-icons/bs";
import AWS from "aws-sdk";
// import ImageUploading from "react-images-uploading";
import {
  ALREADY_EXIST,
  AWS_IMAGE_FOLDER_ITEMS,
  ERROR_MESSAGE,
  REACT_APP_AWSAccessKeyId,
  REACT_APP_AWSSecretKey,
  REACT_APP_REGION,
  SUCCESS_MESSAGE,
  // AWS_IMAGE_FOLDER_ITEMS,
} from "../../../../common/Constant";
import { uploadAWS } from "../../../../common/AWSHelper";
import { toastError, toastSuccess } from "../../../../common/Toast";
import config from "../../../../config/config";
import Loader from "../../../../components/Loader/Loader";
import { useParams, Link } from "react-router-dom";

const Images = (props) => {
  const paramObject = useParams();
  const AWS = require("aws-sdk");
  const Id = localStorage.getItem("ID");
  const token = localStorage.getItem("Token");
  const [previewImage, setPreviewImage] = useState([]);
  const [loading, setLoading] = useState(false);
  const [formValues, setFormValues] = useState({ Image: "" });
  const [changeImagename, setChangeImagename] = useState(false);
  const [ImageUrl, setImageUrl] = useState([]);
  const [btnLoader, setBtnLoader] = useState({ SelectImage: false });
  const [selectedImage, setSelectedImage] = useState("");
  const [variationData, setVariationData] = useState([]);
  const buttonRef = React.useRef(null);
  const handleBack = () => {
    props.previousStep();
    window.scrollTo(0, 0);
  };
  const ActionButtons = (props) => {
    const handleSubmitForm = () => {
      // if (ImageUrl) {
      handleSubmit();
      // }
    };
    const handleNext = () => {
      props.nextStep();
      window.scrollTo(0, 0);
      if (ImageUrl) {
        handleSubmit();
      }
    };

    return (
      <div className="text-center mb-1">
        {props.currentStep > 1 && (
          <button onClick={handleBack} className="btn btn-sm btn-primary me-3">
            Back
          </button>
        )}
        {props.currentStep < props.totalSteps && (
          <button
            onClick={handleNext}
            className="btn btn-sm btn-primary me-3"
            ref={buttonRef}
          >
            Next
          </button>
        )}
        <button
          onClick={handleSubmitForm}
          className="btn btn-sm btn-primary btn-md me-3"
          id="btn_submit"
          type="submit"
        >
          Save
        </button>
        <Link to="/items" className="btn btn-sm btn-secondary btn-md">
          Cancel
        </Link>
      </div>
    );
  };

  console.log("ImageUrl ==>86", ImageUrl);

  // Validation-
  const vaidation = (name, value) => {
    switch (name) {
      case "SelectImage":
        if (!value?.name?.match(/\.(jpg|jpeg|png|gif|pdf)$/)) {
          return false;
        } else {
          return true;
        }
      default: {
        return true;
      }
    }
  };

  const [uploadImageUrl, setUploadImageUrl] = useState([]);
  // Upload File Function-
  const uploadFile = async (file, type, index) => {
    console.log("typeee1", file);
    console.log("typeee1", type);
    setBtnLoader({ [type]: true });
    setLoading(true);

    await uploadAWS(file, AWS_IMAGE_FOLDER_ITEMS, (data) => {
      if (data) {
        console.log("data image 110", data);
        if (type === "SelectImage") {
          if (ImageUrl?.length > 0) {
            setImageUrl([...ImageUrl, data]);
            setUploadImageUrl([...uploadImageUrl, data]);
          } else {
            setImageUrl([data]);
            setUploadImageUrl([data]);
          }
          setLoading(false);
        }
      }
    });
  };

  // Handle Image Change-
  const _handleImageChange = (event, index) => {
    setChangeImagename(true);

    if (vaidation(event?.target?.name, event?.currentTarget?.files[0])) {
      uploadFile(event?.currentTarget?.files[0], event?.target?.name, index);
    }

    const files = event?.target?.files;
    if (files) {
      let images = [];
      for (let i = 0; i < files.length; i++) {
        const reader = new FileReader();
        reader.onload = (e) => {
          images.push({
            name: files[i].name,
            preview: e.target.result,
          });
          setPreviewImage([...previewImage, images]);
        };
        reader.readAsDataURL(files[i]);
      }
    }
    setChangeImagename(false);
  };

  // Handle Image Upload-
  console.log("Filesss3:>", variationData);
  const handleImageUpload = (e, index) => {
    const name = e.target.name;
    const file = e.target.files[0];
    const reader = new FileReader();

    reader.onload = () => {
      const base64Image = reader.result;
      const updatedData = [...variationData];
      updatedData[index] = { ...updatedData[index], [name]: base64Image };
      setVariationData(updatedData);
    };
    reader.readAsDataURL(file);
    console.log("reader 177", reader);
  };
  console.log("variationData 179", variationData);

  // Handle Delete Data-
  const handleDeleteData = (e, index) => {
    const updatedData = [...variationData];
    updatedData[index].ImagesData = null;
    setVariationData(updatedData);
  };

  // AWS configuration-
  AWS.config.update({
    accessKeyId: REACT_APP_AWSAccessKeyId, // Replace with your AWS access key ID
    secretAccessKey: REACT_APP_AWSSecretKey, // Replace with your AWS secret access key
    region: REACT_APP_REGION, // Replace with your AWS region
  });

  const s3 = new AWS.S3();

  // Upload Image To S3-
  async function uploadImageToS3(imageData, uniqueId) {
    const base64Data = imageData.replace(/^data:image\/\w+;base64,/, "");
    const contentType =
      imageData != null && imageData != ""
        ? imageData.match(/^data:image\/(\w+);base64,/)[1]
        : "";
    const byteCharacters = atob(base64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += 1024) {
      const slice = byteCharacters.slice(offset, offset + 1024);
      const byteNumbers = new Array(slice.length);

      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: "image/jpeg" });

    const params = {
      Bucket: "sonarposdev1", // Replace with your S3 bucket name
      Key: `${AWS_IMAGE_FOLDER_ITEMS}/${uniqueId}.jpg`, // Replace with the desired key or filename in S3
      Body: blob,
      ContentType: contentType,
      // ACL: "public-read",
    };

    try {
      await s3.upload(params).promise();
      const imageUrl = `https://sonarposdev1.s3.amazonaws.com/${params.Key}`;
      console.log("imageUrl:", imageUrl);
      return imageUrl;
    } catch (error) {
      console.error("Error uploading image to S3:", error);
      throw error;
    }
  }

  // Generate Unique Id For Image Name-
  function generateUniqueId() {
    return Math.random().toString(36).substring(2, 15);
  }

  console.log("ImageUrl, uploadImageUrl 235", ImageUrl, uploadImageUrl);
  // Handle Submit Data-
  const handleSubmit = async () => {
    setLoading(true);

    const updatedVariationData = await Promise.all(
      variationData?.map(async (obj, index) => {
        const uniqueId = generateUniqueId(); // Function to generate a unique identifier
        // Check if the image already has an AWS S3 URL or if the ImagesData is empty
        if (obj.ImagesData && obj.ImagesData.includes("s3.amazonaws.com")) {
          return obj; // Skip the upload process and keep the original object
        }
        if (
          obj.ImagesData &&
          obj.ImagesData != "" &&
          obj.ImagesData != "null" &&
          obj.ImagesData != null
        ) {
          const imageUrl = await uploadImageToS3(obj.ImagesData, uniqueId);
          return { ...obj, ImagesData: imageUrl };
        }
        return { ...obj, ImagesData: "" }; // Set ImagesData to null if it is empty
      })
    );

    setVariationData(updatedVariationData);
    setLoading(false);
    console.log("AWS IMAGE DATA:>>>>", updatedVariationData);
    // return true;
    let WorkorderEstimatedParts = updatedVariationData.filter(function (
      workOrderEstimated
    ) {
      return workOrderEstimated.itemid != "";
    });
    const workOrderEstimatedobj = {};
    workOrderEstimatedobj.customerTaxXML = WorkorderEstimatedParts;
    let workorderestimatedpartsjsonstring = JSON.stringify(
      workOrderEstimatedobj
    );

    const dataobj = {
      imagenames: uploadImageUrl?.join(","),
      itemid: parseInt(paramObject.id),
      loginuserid: Id,
      XMLvariationImage_upsert: workorderestimatedpartsjsonstring,
    };

    console.log("xmldataaaaa::>>>", dataobj);
    // return true;

    setLoading(true);
    axios
      .post(`${config.itemsBaseUrl}/items/imagesupsert`, dataobj, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS" && res.data.ResponseID > 0) {
          toastSuccess(SUCCESS_MESSAGE);
          setUploadImageUrl([]);
        } else if (
          res.data.ResponseCode === "ERROR" &&
          res.data.ResponseID === -1
        ) {
          // toastError("Name" + ALREADY_EXIST);
        } else {
          toastError(ERROR_MESSAGE);
        }
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  function handleButtonClick() {
    buttonRef.current.click();
  }

  // Use Effect-
  useEffect(() => {
    if (paramObject.id > 0) {
      axios
        .get(
          `${config.itemsBaseUrl}/items/imagesfindbyid?id=${paramObject.id}`,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              Authorization: token,
            },
          }
        )
        .then((res) => {
          // setImageUrl()
          if (res.data.ResponseData.length != 0) {
            setVariationData(res.data.ResponseData);
          } else {
          }
          const newData = res?.data?.ResponseData?.map((el) =>
            el.ImagesData?.split(",")
          )[0];
          console.log(
            "newDAta",
            res?.data?.ResponseData?.map((el) => el.ImagesData?.split(","))[0]
          );
          newData?.length > 0 &&
            setImageUrl(res?.data?.ResponseData?.map((el) => el.ImagesData));
        })
        .catch((err) => {
          console.log("err: ", err);
        });
    }

    axios
      .get(
        `${config.itemsBaseUrl}/items/inventoryfindbyid?id=${paramObject.id}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        const mappedReceivingItems = res.data.ResponseData.Itemsvariations.map(
          (item) => {
            const mappedItem = {
              ID: 0,
              ItemID: item.ItemID,
              VariationID: item.ItemVariationId,
              ImagesData: item.ImagesData ? item.ImagesData : "",
              VariationName: item.VariationName,
              ImagesData: item?.ImageName,
            };
            return mappedItem;
          }
        );

        setVariationData(mappedReceivingItems);
      })
      .catch((err) => {
        console.log("err: ", err);
      });
  }, [props]);

  console.log("ImageUrl 374", ImageUrl);

  return (
    <>
      <Loader loading={loading} />
      <div className="card">
        <div className="card-header d-flex justify-content-between align-items-center p-2">
          <h5 className="card-title">
            <BsImages className="me-1" />
            Upload Images (Fields in red are required)
          </h5>
          <div>
            {props.currentStep > 1 && (
              <button
                onClick={handleBack}
                className="btn btn-sm btn-primary btn-md me-1"
              >
                Back
              </button>
            )}
            {props.currentStep < props.totalSteps && (
              <button
                className="btn btn-sm btn-primary btn-md"
                type="button"
                onClick={handleButtonClick}
              >
                Next
              </button>
            )}
          </div>
        </div>
        <div className="card-body p-1">
          <Formik {...props} initialValues={formValues}>
            <Form onKeyPress={(e) => e.key === "Enter" && e.preventDefault()}>
              {/* Select Image  */}
              <div className="row">
                <div className="col-md-2 mb-1 align-center">
                  <label className="form-label">Select Image/Images</label>
                </div>
                <div className="col-md-5 mb-1">
                  <input
                    type="file"
                    className="form-control form-control-sm"
                    id="SelectImage"
                    name="SelectImage"
                    multiple
                    onChange={_handleImageChange}
                  />
                </div>
              </div>

              {/* Preview Image */}
              <div className="row">
                <div className="col-md-2 mb-1 align-center">Image Preview</div>
                <div
                  className={`${
                    ImageUrl ? "" : selectedImage ? "" : "d-none"
                  } form-group row`}
                >
                  <label className="col-form-label col-md-2 form-label"></label>
                  <div className="col-md-10">
                    {ImageUrl?.map((el) => (
                      <img
                        src={`${el ? el : selectedImage}`}
                        alt="Item_Image"
                        className="ItemImage"
                        style={{
                          height: "70px",
                          width: "70px",
                          marginRight: "0.5rem",
                          border: "1px solid #f0f0f0",
                          borderRadius: "0.5rem",
                        }}
                      />
                    ))}
                  </div>
                </div>
              </div>
            </Form>
          </Formik>
        </div>
        <div className="container w-75 mb-2 p-1">
          <table class="table">
            <thead>
              <tr>
                <th scope="col">Variation Name</th>
                <th scope="col">Variation Images</th>
                <th scope="col">Thumbnail</th>
                <th scope="col">Delete</th>
              </tr>
            </thead>
            <tbody>
              {variationData?.map((items, index) => {
                return (
                  <>
                    <tr key={index}>
                      <td style={{ padding: "0" }}>{items.VariationName}</td>
                      <td style={{ padding: "0" }}>
                        <div class="input-group">
                          <input
                            type="file"
                            class="form-control form-control-sm"
                            name="ImagesData"
                            id="inputGroupFile02"
                            onChange={(e) => handleImageUpload(e, index)}
                          />
                        </div>
                      </td>
                      <td style={{ padding: "0" }}>
                        <img
                          // src={
                          //   items.ImagesData
                          //     ? items.ImagesData == "null"
                          //       ? "https://www.freeiconspng.com/uploads/no-image-icon-4.png"
                          //       : items.ImagesData
                          //     : "https://www.freeiconspng.com/uploads/no-image-icon-4.png"
                          // }
                          src={
                            !items?.ImagesData ||
                            items?.ImagesData === "" ||
                            items?.ImagesData === "null"
                              ? "https://www.freeiconspng.com/uploads/no-image-icon-4.png"
                              : items?.ImagesData
                          }
                          class="img-thumbnail"
                          alt="VariationImage"
                          style={{
                            width: "50px",
                            height: "50px",
                            border: "none",
                          }}
                        ></img>
                      </td>
                      <td style={{ padding: "0" }}>
                        <button
                          className="btn btn-outline-danger btn-sm"
                          onClick={(e) => handleDeleteData(e, index)}
                        >
                          <i className="fa fa-trash"></i>
                        </button>
                      </td>
                    </tr>
                  </>
                );
              })}
            </tbody>
          </table>
        </div>
        <ActionButtons {...props} />
      </div>
    </>
  );
};
export default Images;
